/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeTypeItem } from '../../models/company-office-type-item';

export interface OfficeControllerDeleteOfficeType$Params {
  id: number;
}

export function officeControllerDeleteOfficeType(http: HttpClient, rootUrl: string, params: OfficeControllerDeleteOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerDeleteOfficeType.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeTypeItem;
      }>;
    })
  );
}

officeControllerDeleteOfficeType.PATH = '/company/office/type/{id}';
